import ApiSidebar from "components/apiDocs/ApiSidebar/ApiSidebar";
import BrowseAllPage from "components/apiDocs/BrowseAllPage/BrowseAllPage";
import EndpointPage from "components/apiDocs/EndpointPage/EndpointPage";
import GuidancePage from "components/apiDocs/GettingStartedPage/Guidance/GuidancePage";
import IntroductionPage from "components/apiDocs/GettingStartedPage/IntroductionPage/IntroductionPage";
import SearchResultsPage from "components/apiDocs/SearchResultsPage/SearchResultsPage";
import LoadingSpinner from "components/components/LoadingSpinner/LoadingSpinner";
import { SpinnerContainer } from "components/components/LoadingSpinner/style";
import PageMeta from "components/components/Meta/PageMeta";
import { useSwaggerFile } from "contexts/SwaggerFileContext";
import { RequestStatus } from "hooks/useRequest";
import { Endpoint } from "models/apiDocumentation/apiDocumentationModels";
import GeneralErrorPage from "pages/GeneralErrorPage/GeneralErrorPage";
import React from "react";
import { useParams } from "react-router-dom";
import {
  getEndpointDataByPath,
  transformSwaggerJsonFile,
} from "utils/apiDocumentationUtils";
import { apiDocsRouteSuffixes } from "utils/routeConstants";

import { StyledContent } from "./style";

const ApiDocumentation: React.FC = () => {
  const params = useParams<{ "*": string }>();
  const activePagePath = "/" + params["*"];

  const { data: rawData, status } = useSwaggerFile();

  const apiData = rawData
    ? transformSwaggerJsonFile(rawData)
    : { endpoints: [], tags: [] };

  const selectedEndpointData = activePagePath.startsWith(
    apiDocsRouteSuffixes.endpoint
  )
    ? getEndpointDataByPath(apiData.endpoints, activePagePath)
    : null;

  const renderRelevantPage = (): JSX.Element => {
    if (selectedEndpointData !== null) {
      return <EndpointPage endpointData={selectedEndpointData as Endpoint} />;
    }

    if (activePagePath.startsWith(apiDocsRouteSuffixes.introduction)) {
      return <IntroductionPage />;
    }

    if (activePagePath.startsWith(apiDocsRouteSuffixes.guidance)) {
      return <GuidancePage downloadData={rawData} />;
    }

    if (activePagePath.endsWith(apiDocsRouteSuffixes.searchResults)) {
      return <SearchResultsPage apiData={apiData} />;
    }

    return <BrowseAllPage apiData={apiData} />;
  };

  if (status === RequestStatus.IN_PROGRESS) {
    return (
      <StyledContent>
        <SpinnerContainer>
          <LoadingSpinner isLoading />
        </SpinnerContainer>
      </StyledContent>
    );
  }
  if (status === RequestStatus.ERRORED) {
    return <GeneralErrorPage />;
  }

  return (
    <StyledContent>
      <PageMeta title="API documentation" />
      <ApiSidebar
        apiData={apiData}
        selectedEndpoint={selectedEndpointData}
        activePagePath={activePagePath}
      />
      {renderRelevantPage()}
    </StyledContent>
  );
};

export default ApiDocumentation;
